













































































































import { ROUTES } from "@/constants/routes";
import URLs from "@/constants/urls";
import Vue from "vue";
export default Vue.extend({
  name: "Landing",
  methods: {
    goToHome(): void {
      this.$router.push(ROUTES.HOME.path);
    },
    goToLogin(): void {
      window.location.replace(URLs.url_to_login);
    },
  },
});
